import React from "react";
import {
  Dialog,
  Flex,
  Text,
  Input,
  TextArea,
  Dropdown,
  Button,
  Box,
  Divider,
  Tooltip,
  CloseIcon,
} from "@fluentui/react-northstar";
import { CoinIcon } from "../../../Assets/icons/icons";
import "./MagicBar.scss";
import { useMagicBar } from "../../../context/MagicBarContext";

const languageOptions = [
  { key: "en", header: "English" },
  // Add more languages as needed
];

const MagicBar = ({
  open,
  onClose,
  onGenerate,
  coinBalance = 20,
  content,
  isLoading,
}) => {
  const { user } = useMagicBar();
  return (
    <Dialog
      open={open}
      onCancel={onClose}
      className="magic-bar"
      content={
        <Box
          style={{
            minWidth: 600,
            padding: 24,
            border: "1px solid grey",
            borderRadius: "10px",
          }}
        >
          <Flex column gap="gap.medium">
            <Flex vAlign="center" space="between">
              <Text size="larger" weight="bold">
                Magic ACV bar ✨
              </Text>
              <Button
                iconOnly
                icon={<CloseIcon />}
                disabled={isLoading}
                text
                onClick={onClose}
              />
            </Flex>

            <Box
              styles={{
                background: "#fff",
                borderRadius: "20px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                padding: "4px 12px",
                marginBottom: 8,
                width: "fit-content",
                alignSelf: "end",
              }}
            >
              <Flex gap="gap.smaller" vAlign="center" space="between">
                <div style={{ width: "22px", height: "22px" }}>
                  {CoinIcon()}
                </div>
                <Text>{user.credit}</Text>
              </Flex>
            </Box>
            {content}

            <Flex vAlign="center" space="between">
              <Text color="grey" size="small">
                Review AI limits on our{" "}
                <a
                  href="https://www.acv.app/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tos-link"
                >
                  Terms of Service
                </a>
                .
              </Text>
              <Button
                primary
                data-cy="generate-assignment-content-btn"
                content="Generate it 🌟"
                onClick={onGenerate}
                style={{ minWidth: 140, borderRadius: "5px" }}
                disabled={isLoading}
                loading={isLoading}
              />
            </Flex>
          </Flex>
        </Box>
      }
    />
  );
};

export default MagicBar;
